const zipCodeInLocalStorage = typeof window !== "undefined" && localStorage.getItem("brunchbutler_zipCode");
export const getZipCode = zipCodeInLocalStorage ? (zipCodeInLocalStorage as string).trim() : "";
const cantonInLocalStorage = typeof window !== "undefined" && localStorage.getItem("brunchbutler_canton");
export const getCanton = cantonInLocalStorage ? (cantonInLocalStorage as string).trim() : "";
